import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M 5.493 1.607 c 0.845 -0.395 1.799 -0.187 2.555 0.292 l 0.03 0.02 l 11.017 8.111 c 0.781 0.464 1.504 1.175 1.505 2.172 c 0.001 0.99 -0.715 1.734 -1.496 2.246 l -10.93 7.644 l -0.046 0.025 c -0.788 0.437 -1.762 0.706 -2.63 0.242 c -0.879 -0.47 -1.193 -1.442 -1.25 -2.387 l -0.001 -0.028 L 4.2 3.968 c -0.019 -1.02 0.395 -1.943 1.292 -2.361 Z m 0.781 1.885 c -0.032 0.062 -0.079 0.198 -0.074 0.445 v 0.009 l 0.047 15.934 c 0.035 0.534 0.165 0.686 0.194 0.714 c 0.035 0.008 0.227 0.037 0.676 -0.203 l 10.867 -7.6 l 0.014 -0.01 c 0.289 -0.188 0.451 -0.347 0.535 -0.46 a 0.428 0.428 0 0 0 0.064 -0.111 c -0.017 -0.044 -0.107 -0.22 -0.553 -0.477 l -0.048 -0.028 L 6.95 3.572 c -0.37 -0.225 -0.579 -0.169 -0.611 -0.153 c -0.014 0.006 -0.037 0.019 -0.066 0.073 Z"
  />,
  'Play3'
)
